import { Box, Button, Grid, IconButton, Typography } from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import colors from "../../../colors";
import { useEffect, useState } from "react";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";

const MainView = ({ exchanges, setMoreInfo }) => {
  const [activeStep, setActiveStep] = useState(0);
  const maxSteps = exchanges.length;

  const handleNext = () => {
    {
      activeStep === maxSteps - 1
        ? setActiveStep(0)
        : setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    {
      activeStep === 0
        ? setActiveStep(maxSteps - 1)
        : setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      {
        activeStep === maxSteps - 1
          ? setActiveStep(0)
          : setActiveStep((prevActiveStep) => prevActiveStep + 1);
      }
    }, 3000);

    return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  }, [activeStep]);

  return (
    <>
      <IconButton onClick={handleBack} disableRipple={true}>
        <KeyboardArrowLeft />
      </IconButton>
      <Grid
        container
        item
        md={2}
        xs={1}
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"center"}
      >
        <Box
          sx={{
            height: "50px",
            background: colors.white,
            borderRadius: "100%",
          }}
        >
          <img
            src={maxSteps > 0 ? exchanges[activeStep].imageUrl : undefined}
            alt="flag"
            width={"50px"}
          />
        </Box>
      </Grid>
      <Grid
        container
        item
        md={6}
        xs={7}
        justifyContent={"space-around"}
        alignItems={"center"}
        flexDirection={"center"}
      >
        <Typography
          sx={{
            fontSize: "1rem",
            color: colors.darkBlue,
            fontFamily: "GerberaBold",
          }}
        >
          Blihet:{" "}
          <span
            style={{
              fontSize: "0.9rem",
              color: colors.darkBlue,
              fontFamily: "GerberaMedium",
            }}
          >
            {maxSteps > 0 ? exchanges[activeStep].blihet : undefined}
          </span>
        </Typography>
        <Typography
          sx={{
            fontSize: "1rem",
            color: colors.darkBlue,
            fontFamily: "GerberaBold",
          }}
        >
          Shitet:{" "}
          <span
            style={{
              fontSize: "0.9rem",
              color: colors.darkBlue,
              fontFamily: "GerberaMedium",
            }}
          >
            {maxSteps > 0 ? exchanges[activeStep].shitet : undefined}
          </span>
        </Typography>
      </Grid>
      <Grid
        container
        item
        md={2}
        xs={1}
        justifyContent={"center"}
        alignItems={"center"}
        flexDirection={"center"}
      >
        <Button
          disableRipple={true}
          sx={{ ":hover": { background: colors.white } }}
          onClick={setMoreInfo}
        >
          <Box
            sx={{
              width: "45px",
              height: "45px",
              background: colors.lightOrange,
              borderRadius: "10px",
            }}
          >
            <Grid
              container
              justifyContent={"center"}
              alignItems={"center"}
              flexDirection={"column"}
              mt={1.3}
            >
              <SwapHorizIcon color="warning" />
            </Grid>
          </Box>
        </Button>
      </Grid>
      <IconButton onClick={handleNext} disableRipple={true}>
        <KeyboardArrowRight />
      </IconButton>
    </>
  );
};

export default MainView;
